import { useTranslation } from "react-i18next";
import { MapPin } from "lucide-react";
import { NeuCard, NeuSelect } from "../../components/neu/Neu";
import { GeoBadge } from "./GeoBadge";

// ظل 3D للحاوية الخارجية فقط — بلا تغيير للأحجام أو الألوان الداخلية.
const BAR_3D = {
  boxShadow:
    "0 14px 28px rgba(0,0,0,0.32), 0 8px 12px rgba(0,0,0,0.20),"
    + " inset 0 1.5px 0 rgba(255,255,255,0.28), inset 0 -4px 10px rgba(0,0,0,0.18)",
};

export const CheckInBar = ({ branches, branchId, setBranchId, nextAction, geo, geoError, locating, absent, leaveType, day }) => {
  const { t } = useTranslation();
  const offDay = day && day.day_type !== "workday";
  const offLabel = day?.day_type === "holiday"
    ? t("offDay.holidayTitle", { name: day.holiday_name || "" })
    : t("offDay.weekendTitle");
  const leaveLabel = leaveType ? t("leaveStatus.onLeave", { type: t(`leaveStatus.types.${leaveType}`) }) : null;
  const label = offDay && !day.work_allowed
    ? offLabel
    : leaveLabel || (absent ? t("absent.title") : nextAction ? t(`check.${nextAction}`) : t("check.done"));
  const multi = branches.length > 1;

  return (
    <NeuCard className="animate-rise-in p-4" data-testid="check-in-bar" style={BAR_3D}>
      {multi ? (
        <div className="w-full sm:max-w-xs">
          <p className="label-xs text-sm">{t("check.branch")}</p>
          <NeuSelect
            data-testid="branch-select"
            className="mt-2"
            value={branchId}
            onChange={(e) => setBranchId(e.target.value)}
          >
            {branches.map((b) => (
              <option key={b.id} value={b.id}>
                {b.name}
              </option>
            ))}
          </NeuSelect>
        </div>
      ) : null}

      <div className={`flex flex-wrap items-center gap-2 ${multi ? "mt-3" : ""}`}>
        {!multi ? (
          <span className="flex min-w-0 items-center gap-1 text-sm font-bold" data-testid="branch-name">
            <MapPin className="h-3.5 w-3.5 shrink-0 text-primary" />
            <span className="truncate">{branches[0]?.name || t("check.selectBranch")}</span>
          </span>
        ) : null}
        <GeoBadge geo={geo} loading={locating} error={geoError} />
        <span
          data-testid="next-action-hint"
          className={`rounded-full border px-3 py-1.5 text-[13px] font-bold ${
            offDay && !day.work_allowed
              ? "border-sky-500/50 text-sky-500"
              : leaveType ? "border-emerald-500/50 text-emerald-600"
              : absent ? "border-destructive/50 text-destructive" : "border-primary/40 text-primary"
          }`}
        >
          {leaveType || absent || (offDay && !day.work_allowed) ? label : `${label} · ${t("check.useFab")}`}
        </span>
        {offDay && day.work_allowed ? (
          <span className="rounded-full bg-primary/10 px-3 py-1.5 text-[13px] font-bold text-primary"
                data-testid="off-day-allowed-chip">
            {t("offDay.allowed")}
          </span>
        ) : null}
      </div>
    </NeuCard>
  );
};
